<template>
  <div class="sub-toolbar">
    <simple-toolbar>
      <md-button
        class="md-dense md-raised md-primary"
        v-if="$config.feature.creditAlarm"
        @click="
          openAdd(showAccountBalance ? 'account_balance' : 'promotion_credit')
        "
        >{{
          L(showAccountBalance ? 'addAccountBalance' : 'addPromotionCredit')
        }}</md-button
      >
      <md-button
        class="md-dense md-raised md-primary"
        v-if="$config.feature.budgetAlarm"
        @click="openAdd('budget')"
        >{{ L('addBudget') }}</md-button
      >
    </simple-toolbar>

    <md-content>
      <md-table v-model="alarmData" md-stripe class="fixed-header-table">
        <md-table-empty-state :md-label="C('noData')" />
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="L('seq')">{{ item.seq }}</md-table-cell>
          <md-table-cell :md-label="L('name')">{{ item.name }}</md-table-cell>
          <md-table-cell :md-label="L('type')">{{
            item.type.replace('_', ' ')
          }}</md-table-cell>
          <md-table-cell
            :md-label="L('targetName')"
            v-if="$config.feature.project"
          >
            {{ item.data.map((res) => res.name).join(',') | ellipsis(100) }}
            <md-tooltip class="tooltip">{{
              item.data.map((res) => res.name).join(', ')
            }}</md-tooltip>
          </md-table-cell>
          <md-table-cell :md-label="L('targetAmount')"
            >{{ checkCurrency(item.target.currency)
            }}{{ item.target.amount | round2 }}</md-table-cell
          >
          <md-table-cell :md-label="L('setting')">{{
            addStandard(item.setting, item.target.currency)
          }}</md-table-cell>
          <md-table-cell :md-label="L('action')">
            <md-button
              class="md-icon-button md-dense"
              @click="openModify(item)"
            >
              <fa-icon icon="pencil-alt" />
            </md-button>
            <md-button
              class="md-icon-button md-dense"
              @click="openRemove(item)"
            >
              <fa-icon icon="trash-alt" />
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-content>

    <!-- add dialog -->
    <md-dialog
      :md-active.sync="dialog.add"
      v-if="dialog.add"
      class="md-dialog-big"
    >
      <md-dialog-title>{{ dialogTitle }}</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field :class="`${inputStatus.name ? 'md-invalid' : ''}`">
              <label>{{ L('name') }}</label>
              <md-input v-model="dialog.item.name" required />
            </md-field>
          </div>
          <div
            class="md-layout-item md-size-33"
            v-if="
              $config.feature.project &&
              dialog.item.type === 'budget' &&
              showAllProjectToggle
            "
          >
            <md-checkbox
              v-model="allProject"
              class="md-primary"
              style="margin: 30px 0 0 0"
              @change="changeProjectsSummary"
              >{{ L('allProjects') }}</md-checkbox
            >
          </div>
        </div>

        <div v-if="dialog.item.type === 'promotion_credit'">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field :class="`${inputStatus.data ? 'md-invalid' : ''}`">
                <label>{{ L('creditName') }}</label>
                <md-select
                  class="md-select-md-size"
                  v-model="creditId"
                  required
                  @md-selected="changeOriginalAmount"
                  :md-minwidth="500"
                >
                  <md-option
                    v-for="data in promotionCreditData"
                    :key="data.id"
                    :value="data.id"
                    >{{ data.name }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>{{ L('totalCredit') }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input v-model="dialog.item.target.amount" disabled />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>{{
                  L(showAccountBalance ? 'usageBalance' : 'usageCredit')
                }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input v-model="dialog.item.usage_amount" disabled />
              </md-field>
            </div>
          </div>
        </div>

        <div v-if="dialog.item.type === 'account_balance'">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field :class="`${inputStatus.data ? 'md-invalid' : ''}`">
                <label>{{ L('balanceName') }}</label>
                <md-select
                  class="md-select-md-size"
                  v-model="creditId"
                  required
                  @md-selected="changeOriginalAmountByAccountBalance"
                  :md-minwidth="500"
                >
                  <md-option
                    v-for="data in promotionCreditData.filter(({ id }) =>
                      $config.accountBalanceTypes.includes(id)
                    )"
                    :key="data.id"
                    :value="data.id"
                    >{{ data.name }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>{{ L('totalBalance') }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input v-model="dialog.item.target.amount" disabled />
              </md-field>
            </div>
          </div>
        </div>

        <div v-if="dialog.item.type === 'budget'">
          <div
            class="md-layout md-gutter"
            v-if="$config.feature.project && !allProject"
          >
            <div class="md-layout-item">
              <md-field :class="`${inputStatus.data ? 'md-invalid' : ''}`">
                <label>{{ L('projectName') }}</label>
                <md-select
                  v-model="projects"
                  multiple
                  required
                  @md-selected="changeProjectsSummary"
                >
                  <md-button
                    class="md-dense md-raised"
                    @click="selectAllProjects"
                    >{{ L('allProjects') }}</md-button
                  >
                  <md-option
                    v-for="data in projectData"
                    :key="data.id"
                    :value="data.id"
                    >{{ data.name }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter" style="margin-top: 15px">
            <div class="md-layout-item">
              <p class="description">{{ L('budgetDescription') }}</p>
              <div style="display: flex">
                <md-field
                  style="margin-bottom: 10px; width: 270px; margin-right: 15px"
                >
                  <label>{{ L('budgetType') }}</label>
                  <md-select
                    v-model="dialog.item.target.type"
                    required
                    @md-selected="changeProjectsSummary"
                  >
                    <md-option value="specified_amount">{{
                      L('specifiedAmount')
                    }}</md-option>
                    <md-option value="last_month_spend">{{
                      L('lastMonthSpend')
                    }}</md-option>
                  </md-select>
                </md-field>
                <md-field style="margin-bottom: 10px; width: 150px">
                  <label>{{ L('currency') }}</label>
                  <md-select
                    v-model="dialog.item.target.currency"
                    required
                    @md-selected="changeProjectsSummary"
                  >
                    <md-option
                      v-for="currency in currencies"
                      :key="currency.value"
                      :value="currency.value"
                      >{{ currency.value }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <p class="description">
                {{
                  dialog.item.target.type === 'specified_amount'
                    ? L('specifiedAmountDescription')
                    : L('lastMonthSpendDescription')
                }}
              </p>
            </div>
          </div>
          <div class="md-layout md-gutter" style="margin-top: 10px">
            <div class="md-layout-item">
              <md-field
                :class="`${inputStatus.targetAmount ? 'md-invalid' : ''}`"
              >
                <label>{{ L('targetAmount') }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input
                  v-model="dialog.item.target.amount"
                  type="number"
                  required
                  :disabled="!checkSpecifiedAmount()"
                />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-checkbox
                v-model="applyDiscount"
                class="md-primary apply-discount md-small-size-100 md-xsmall-size-100"
                style="margin-top: 0px"
                @change="changeProjectsSummary"
                >{{ `${L('applyDiscount')}` }}</md-checkbox
              >
            </div>
          </div>
        </div>

        <div
          class="md-layout md-gutter"
          style="margin-top: 25px; margin-bottom: 10px"
        >
          <div class="md-layout-item">
            <div>
              <label>{{ L('setting') }}</label>
              <p class="description">{{ settingDescription }}</p>
            </div>
            <div
              class="setting-area"
              v-for="(setting, i) in dialog.item.setting"
              :key="i"
            >
              <div class="setting-select-area">
                <md-field class="field-area" style="margin-bottom: 10px">
                  <md-select v-model="setting.type" required>
                    <md-option
                      v-for="type in settingTypes"
                      :key="type"
                      :value="type"
                      >{{ checkSettingType(type) }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="setting-input-item">
                <md-field class="field-area" style="margin-bottom: 10px">
                  <md-input v-model="setting.value" type="number" />
                </md-field>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field :class="`${inputStatus.cc ? 'md-invalid' : ''}`">
              <label>{{ L('cc') }}</label>
              <md-input
                v-model="dialog.item.cc"
                placeholder="CC mail address: megazone@mz.co.kr,gcp@mz.co.kr"
              />
            </md-field>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="closeAddModify()">{{
          L('cancel')
        }}</md-button>
        <md-button class="md-primary md-raised" @click="add()">{{
          L('save')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- modify dialog -->
    <md-dialog
      :md-active.sync="dialog.modify"
      v-if="dialog.modify"
      class="md-dialog-big"
    >
      <md-dialog-title>{{ L('modifyAlarm') }}</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field :class="`${inputStatus.name ? 'md-invalid' : ''}`">
              <label>{{ L('name') }}</label>
              <md-input v-model="dialog.item.name" required />
            </md-field>
          </div>
          <div
            class="md-layout-item md-size-33"
            v-if="
              $config.feature.project &&
              dialog.item.type === 'budget' &&
              showAllProjectToggle
            "
          >
            <md-checkbox
              v-model="allProject"
              class="md-primary"
              style="margin: 30px 0 0 0"
              @change="changeProjectsSummary"
              >{{ L('allProjects') }}</md-checkbox
            >
          </div>
        </div>

        <div v-if="dialog.item.type === 'promotion_credit'">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field :class="`${inputStatus.data ? 'md-invalid' : ''}`">
                <label>{{ L('creditName') }}</label>
                <md-select
                  class="md-select-md-size"
                  v-model="creditId"
                  required
                  @md-selected="changeOriginalAmount"
                  :md-minwidth="500"
                >
                  <md-option
                    v-for="data in promotionCreditData"
                    :key="data.id"
                    :value="data.id"
                    >{{ data.name }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>{{ L('totalCredit') }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input v-model="dialog.item.target.amount" disabled />
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>{{ L('usageCredit') }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input v-model="dialog.item.usage_amount" disabled />
              </md-field>
            </div>
          </div>
        </div>

        <div v-if="dialog.item.type === 'account_balance'">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field :class="`${inputStatus.data ? 'md-invalid' : ''}`">
                <label>{{ L('balanceName') }}</label>
                <md-select
                  class="md-select-md-size"
                  v-model="creditId"
                  required
                  @md-selected="changeOriginalAmount"
                  :md-minwidth="500"
                >
                  <md-option
                    v-for="data in promotionCreditData.filter(({ id }) =>
                      $config.accountBalanceTypes.includes(id)
                    )"
                    :key="data.id"
                    :value="data.id"
                    >{{ data.name }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>{{ L('totalBalance') }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input v-model="dialog.item.target.amount" disabled />
              </md-field>
            </div>
          </div>
        </div>

        <div v-if="dialog.item.type === 'budget'">
          <div
            class="md-layout md-gutter"
            v-if="$config.feature.project && !allProject"
          >
            <div class="md-layout-item">
              <md-field :class="`${inputStatus.data ? 'md-invalid' : ''}`">
                <label>{{ L('projectName') }}</label>
                <md-select
                  v-model="projects"
                  multiple
                  required
                  @md-selected="changeProjectsSummary"
                >
                  <md-button
                    class="md-dense md-raised"
                    @click="selectAllProjects"
                    >{{ L('allProjects') }}</md-button
                  >
                  <md-option
                    v-for="data in projectData"
                    :key="data.id"
                    :value="data.id"
                    >{{ data.name }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-gutter" style="margin-top: 20px">
            <div class="md-layout-item">
              <p class="description">{{ L('budgetDescription') }}</p>
              <div style="display: flex">
                <md-field
                  style="margin-bottom: 10px; width: 270px; margin-right: 15px"
                >
                  <label>{{ L('budgetType') }}</label>
                  <md-select
                    v-model="dialog.item.target.type"
                    required
                    @md-selected="changeProjectsSummary"
                  >
                    <md-option value="specified_amount">{{
                      L('specifiedAmount')
                    }}</md-option>
                    <md-option value="last_month_spend">{{
                      L('lastMonthSpend')
                    }}</md-option>
                  </md-select>
                </md-field>
                <md-field style="margin-bottom: 10px; width: 150px">
                  <label>{{ L('currency') }}</label>
                  <md-select
                    v-model="dialog.item.target.currency"
                    required
                    @md-selected="changeProjectsSummary"
                  >
                    <md-option
                      v-for="currency in currencies"
                      :key="currency.value"
                      :value="currency.value"
                      >{{ currency.value }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <p class="description">
                {{
                  dialog.item.target.type === 'specified_amount'
                    ? L('specifiedAmountDescription')
                    : L('lastMonthSpendDescription')
                }}
              </p>
            </div>
          </div>
          <div class="md-layout md-gutter" style="margin-top: 10px">
            <div class="md-layout-item">
              <md-field
                :class="`${inputStatus.targetAmount ? 'md-invalid' : ''}`"
              >
                <label>{{ L('targetAmount') }}</label>
                <span class="md-prefix">{{
                  checkCurrency(dialog.item.target.currency)
                }}</span>
                <md-input
                  v-model="dialog.item.target.amount"
                  type="number"
                  required
                  :disabled="!checkSpecifiedAmount()"
                />
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-checkbox
                v-model="applyDiscount"
                class="md-primary apply-discount md-small-size-100 md-xsmall-size-100"
                style="margin-top: 0px"
                @change="changeProjectsSummary"
                >{{ `${L('applyDiscount')}` }}</md-checkbox
              >
            </div>
          </div>
        </div>

        <div
          class="md-layout md-gutter"
          style="margin-top: 15px; margin-bottom: 10px"
        >
          <div class="md-layout-item">
            <div>
              <label>{{ L('setting') }}</label>
              <p class="description">{{ settingDescription }}</p>
            </div>
            <div
              class="setting-area"
              v-for="(setting, i) in dialog.item.setting"
              :key="i"
            >
              <div class="setting-select-area">
                <md-field class="field-area" style="margin-bottom: 10px">
                  <md-select v-model="setting.type" required>
                    <md-option v-for="t in settingTypes" :key="t" :value="t">{{
                      checkSettingType(t)
                    }}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="setting-input-item">
                <md-field class="field-area" style="margin-bottom: 10px">
                  <md-input v-model="setting.value" type="number" />
                </md-field>
              </div>
            </div>
          </div>
        </div>

        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field :class="`${inputStatus.cc ? 'md-invalid' : ''}`">
              <label>{{ L('cc') }}</label>
              <md-input
                v-model="dialog.item.cc"
                placeholder="CC mail address: megazone@mz.co.kr,gcp@mz.co.kr"
              />
            </md-field>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="closeAddModify()">{{
          L('cancel')
        }}</md-button>
        <md-button class="md-primary md-raised" @click="modify()">{{
          L('save')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- remove dialog -->
    <md-dialog-confirm
      :md-active.sync="dialog.remove"
      :md-title="L('removeAlarm')"
      :md-content="L('confirmRemove') + ` (${dialog.item.seq})?`"
      :md-confirm-text="L('remove')"
      :md-cancel-text="L('cancel')"
      @md-confirm="remove()"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api'
import { convertCosts } from '@/lib/utils'
import SimpleToolbar from '@/views/layout/SimpleToolbar'
import moment from 'moment'
import { getExchangeRate } from '@/lib/exchangeRate'
import { currencies } from '@/lib/code'

export default {
  components: { SimpleToolbar },

  async mounted() {
    this.preMonth = moment()
      .startOf('month')
      .subtract(1, 'month')
      .format('YYYY-MM')
    await getExchangeRate(this.preMonth)

    this.load()
  },

  data: () => ({
    settingTypes: ['percentage', 'amount'],
    promotionCreditData: [],
    alarmData: [],
    projectData: [],
    dialog: {
      add: false,
      modify: false,
      remove: false,
      item: {
        data: [],
        setting: [{}, {}, {}],
      },
    },
    inputStatus: {
      name: false,
      data: false,
      setting: false,
      targetAmount: false,
      cc: false,
    },
    projects: [],
    creditId: '',
    allSelectProjects: false,
    checkDiscount: false,
    currencies,
    modifyCheck: false,
    emails: [],
    allProject: false,
    showAllProjectToggle: false,
    summaryData: [],
  }),

  computed: {
    ...mapState({
      curAccount: (state) => state.curAccount,
      userInfo: (state) => state.userInfo,
      exchangeRateList: (state) => state.exchangeRateList,
      creditFilter: (state) => state.creditFilter,
    }),

    showAccountBalance() {
      return this.$config.feature.accountBalance
    },

    applyDiscount: {
      get() {
        return this.checkDiscount
      },
      set(val) {
        this.checkDiscount = val
      },
    },

    monthlyCost() {
      if (!this.summaryData) return []
      return this.summaryData.data.map((d) => {
        d.data.forEach((a) => {
          d.item = this.convertCosts(a.costs)
        })
        return d
      })
    },

    dialogTitle() {
      switch (this.dialog.item.type) {
        case 'promotion_credit':
          return this.L('addPromotionCredit')
        case 'account_balance':
          return this.L('addAccountBalance')
        case 'budget':
          return this.L('addBudget')
        default:
          return this.L('addBudget')
      }
    },

    settingDescription() {
      switch (this.dialog.item.type) {
        case 'promotion_credit':
          return this.L('creditSettingDescription')
        case 'account_balance':
          return this.L('balanceSettingDescription')
        default:
          return this.L('budgetSettingDescription')
      }
    },
  },

  watch: {
    curAccount() {
      this.load()
    },
    userInfo() {
      this.load()
    },
  },

  methods: {
    async load() {
      if (!this.userInfo.seq || !this.curAccount.id) {
        return
      }
      const summary = await api.aggregate.summary(
        this.curAccount.id,
        this.preMonth
      )
      this.summaryData = summary.find((s) => s.kind === 'monthly_cost')

      this.promotionCreditData = await api.promotionCredit.list(
        this.curAccount.id
      )
      this.promotionCreditData = this.promotionCreditData.filter(
        (res) =>
          res.expired_at === null ||
          new Date(res.expired_at).getTime() > new Date().getTime()
      )

      this.alarmData = await api.alarm.list(
        this.curAccount.id,
        this.userInfo.seq
      )

      if (this.$config.feature.project) {
        const projects = await api.account.projects(this.curAccount.id)
        if (
          this.userInfo.resource.allAccount ||
          this.userInfo.resource.projects[this.curAccount.id].includes('*')
        ) {
          this.showAllProjectToggle = true
          this.projectData = projects
        } else {
          this.showAllProjectToggle = false
          this.projectData = []
          this.userInfo.resource.projects[this.curAccount.id].forEach((id) => {
            const item = projects.find((p) => p.id === id)
            if (item) {
              this.projectData.push(item)
            }
          })
        }
      }
    },

    getExchangeRate(currency) {
      const er = this.exchangeRateList.find(
        (e) => e.month === this.preMonth && e.code === currency
      )
      return er ? er.send_rate : { finalCost: 0 }
    },

    convertCosts(costs) {
      const enabled = this.applyDiscount
        ? this.creditFilter.filters.map((f) => f.id)
        : []
      const creditFilter = {
        filters: this.creditFilter.filters,
        enabled,
        applyDiscount: this.applyDiscount,
      }

      return convertCosts(
        costs,
        this.dialog.item.target.currency,
        this.getExchangeRate.bind(this),
        null,
        creditFilter
      )
    },

    addStandard(setting, currency) {
      const result = []
      setting.forEach((s) => {
        result.push(
          s.type === 'percentage'
            ? `${s.value}%`
            : this.checkCurrency(currency) + s.value
        )
      })
      return result.join(', ')
    },

    checkEmails(emails) {
      const emailArr =
        emails.length > 0 ? emails.split(',').map((e) => e.trim()) : []
      const regExp =
        /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i

      const isEmail = emailArr.every((e) => regExp.test(e))
      this.emails = isEmail ? emailArr : []

      return isEmail
    },

    defaltValidationStatus() {
      this.inputStatus.name = false
      this.inputStatus.data = false
      this.inputStatus.setting = false
      this.inputStatus.targetAmount = false
      this.inputStatus.cc = false
    },

    inputValidation(item) {
      let regexpStatus = false
      this.inputStatus.name = true
      this.inputStatus.data = true
      this.inputStatus.setting = true
      this.inputStatus.targetAmount = true
      this.inputStatus.cc = true

      if (item.name) this.inputStatus.name = false
      if (item.data.length > 0) this.inputStatus.data = false
      if (item.setting.filter((res) => res.value).length > 0)
        this.inputStatus.setting = false
      if (item.target.amount && item.target.amount >= 0)
        this.inputStatus.targetAmount = false
      if (this.checkEmails(this.dialog.item.cc)) this.inputStatus.cc = false

      if (
        !this.inputStatus.name &&
        !this.inputStatus.data &&
        !this.inputStatus.setting &&
        !this.inputStatus.targetAmount &&
        !this.inputStatus.cc
      ) {
        regexpStatus = true
      }

      return regexpStatus
    },

    openAdd(type) {
      const { seq, email, name } = this.userInfo

      this.defaltValidationStatus()
      this.dialog.add = true
      this.creditId = ''
      this.projects = []
      this.emails = []
      this.allProject = false
      this.allSelectProjects = false
      this.dialog.item = {
        type,
        data: this.$config.feature.project
          ? []
          : [{ id: '__account', name: '' }],
        name: '',
        account_id: this.curAccount.id,
        user_seq: seq,
        user: JSON.stringify({ user_seq: seq, email, name }),
        setting: [
          { type: 'percentage' },
          { type: 'percentage' },
          { type: 'percentage' },
        ],
        target: {
          amount: 0,
          currency: currencies[0].value,
          type: 'specified_amount',
        },
        cc: [],
      }
    },

    add() {
      if (!this.inputValidation(this.dialog.item)) {
        return
      }
      this.closeAddModify()
      this.putSetting()
      this.putData()
      api.alarm.add(this.curAccount.id, this.dialog.item).then(this.load)
    },

    closeAddModify() {
      this.dialog.add = false
      this.dialog.modify = false
    },

    openModify(item) {
      this.modifyCheck = true
      this.defaltValidationStatus()

      api.alarm
        .get(this.curAccount.id, this.userInfo.seq, item.seq)
        .then((res) => {
          this.dialog.item = res
          this.dialog.item.cc = this.dialog.item.cc
            ? this.dialog.item.cc.join(',')
            : []

          if (res.type === 'promotion_credit') {
            this.creditId = res.data[0].id
            this.changeOriginalAmount()
          } else if (res.type === 'account_balance') {
            this.creditId = res.data[0].id
            this.changeOriginalAmountByAccountBalance()
          } else {
            if (item.data.find((data) => data.id === '__account')) {
              this.allProject = true
            } else {
              this.allProject = false
            }
            this.projects = res.data.map((project) => project.id)
            this.dialog.item.target.type = res.target.type
            this.applyDiscount = res.target.discount
            this.allSelectProjects = true
          }

          for (let i = 0; i < 3 - item.setting.length; i += 1) {
            res.setting.push({ type: 'percentage' })
          }
          this.dialog.modify = true
        })
    },

    modify() {
      if (!this.inputValidation(this.dialog.item)) {
        return
      }
      this.closeAddModify()
      this.putSetting()
      this.putData()

      api.alarm.modify(this.curAccount.id, this.dialog.item).then(this.load)
    },

    openRemove(item) {
      this.dialog.item = item
      this.dialog.remove = true
    },

    remove() {
      api.alarm.remove(this.curAccount.id, this.dialog.item.seq).then(this.load)
    },

    changeOriginalAmount() {
      const array = []
      this.dialog.item.target.amount = 0
      this.dialog.item.usage_amount = 0

      const credit = this.promotionCreditData.find(
        (res) => res.id === this.creditId
      )
      if (!credit || credit.original_amount <= 0) return

      this.dialog.item.target.amount = this.math.round2(
        credit.original_amount / 1000000
      )
      this.dialog.item.usage_amount = this.math.round2(
        (credit.original_amount - credit.remain_amount) / 1000000
      )
      this.dialog.item.target.currency = credit.currency

      array.push({ id: credit.id, name: credit.name })
      this.dialog.item.data = array
    },

    changeOriginalAmountByAccountBalance() {
      const array = []
      this.dialog.item.target.amount = 0
      this.dialog.item.usage_amount = 0

      const credit = this.promotionCreditData.find(
        (res) => res.id === this.creditId
      )

      if (!credit || credit.original_amount <= 0) return

      this.dialog.item.target.amount = this.math.round2(credit.original_amount)
      this.dialog.item.usage_amount = this.math.round2(
        credit.original_amount - credit.remain_amount
      )
      this.dialog.item.target.currency = credit.currency

      array.push({ id: credit.id, name: credit.name })
      this.dialog.item.data = array
    },

    changeProjectsSummary() {
      const array = []
      let cost = 0
      let finalCost = 0

      if (!this.$config.feature.project || this.allProject) {
        this.projects = []
        array.push({ id: '__account', name: '' })
        const summary = this.monthlyCost.find((i) => i.project_id === '__total')
        if (summary) {
          cost += summary.item.cost
          finalCost += summary.item.finalCost
        }
      } else {
        const projects = this.projectData.filter((i) =>
          this.projects.includes(i.id)
        )
        projects.forEach((project) => {
          array.push({ id: project.id, name: project.name })
          const summary = this.monthlyCost.find(
            (i) => i.project_id === project.id
          )
          if (summary) {
            cost += summary.item.cost
            finalCost += summary.item.finalCost
          }
        })
      }

      this.dialog.item.data = array
      if (!this.checkSpecifiedAmount()) {
        this.dialog.item.target.amount = !this.applyDiscount
          ? Number(cost.toFixed(2))
          : Number(finalCost.toFixed(2))
        this.modifyCheck = false
      } else {
        if (!this.modifyCheck) {
          this.dialog.item.target.amount = 0
          this.modifyCheck = true
        }
      }
    },

    checkSpecifiedAmount() {
      if (this.dialog.item.target.type === 'specified_amount') return true
      return false
    },

    putSetting() {
      const setting = this.dialog.item.setting.filter(
        (res) => res.value && res.type !== ''
      )
      setting.map((res) => {
        res.send_at = ''
        return res
      })
      this.dialog.item.setting = JSON.stringify(setting)
    },

    checkSettingType(type) {
      if (type === 'percentage') return '%'
      if (type === 'amount')
        return this.checkCurrency(this.dialog.item.target.currency)
      return type
    },

    selectAllProjects() {
      this.projects = this.allSelectProjects
        ? []
        : this.projectData.map((project) => project.id)
      this.allSelectProjects = !this.allSelectProjects
    },

    putData() {
      this.dialog.item.data = JSON.stringify(this.dialog.item.data)
      const { currency, amount, type } = this.dialog.item.target
      const discount = this.applyDiscount
      this.dialog.item.cc = this.emails

      if (
        ['promotion_credit', 'account_balance'].includes(this.dialog.item.type)
      ) {
        this.dialog.item.target = JSON.stringify({ currency, amount })
      } else {
        this.dialog.item.target = JSON.stringify({
          type,
          discount,
          currency,
          amount,
        })
      }
    },

    checkCurrency(currency) {
      return currencies.find((c) => c.value === currency).unit
    },
  },
}
</script>

<style lang="scss" scoped>
.md-content {
  padding: 8px;
}

.setting-select-area {
  width: 150px;
  margin-right: 15px;
  padding-top: 0px;
}

.setting-input-item {
  width: 270px;
  padding-top: 0px;
}

.setting-area {
  display: flex;
}

.field-area {
  min-height: 20px;
  padding-top: 0px;
}

.md-dialog-big ::v-deep .md-dialog-container {
  width: 500px;
}

.description {
  font-size: 12px;
}

.tooltip {
  height: auto;
  white-space: normal;
  width: 500px;
  line-height: 15px;
  padding: 6px 8px;
}
</style>
